var $ = jQuery;

$(document).on('ready', function(){
    $(document).on('click', '.gallery-btn', function() {
        $('body').addClass('overflow-hidden');
    })
    
    $(document).on('click', '.close-gallery', function() {
        $('body').removeClass('overflow-hidden');
    })
})